export const formatDate = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const handleGetEditingDataPoint = (
  goalData,
  user,
  formState,
  studentGoalsData
) => {
  if (!goalData) return null;

  const goalID = goalData?.goalID;
  const dataEntryID = goalData?.dataEntryID;

  if (!goalID || !dataEntryID) return null;

  const studentId = user?.studentId || user?.id || formState?.studentId;

  if (!studentId) return null;

  const studentGoals = studentGoalsData?.find(
    (student) => student.id === studentId
  );

  if (!studentGoals) return null;

  // Find goal by checking both id and docId
  const goal = studentGoals?.dataCollection?.find(
    (collection) => (collection?.id || collection?.docId) === goalID
  );
  if (!goal) return null;

  // Ensure goalData is an array (it might be "No data available" string)
  const goalDataArray = Array.isArray(goal.goalData) ? goal.goalData : [];

  if (goalDataArray.length === 0) return null;

  // Find dataEntry by checking both id and docId
  const dataEntry = goalDataArray.find(
    (d) => (d?.id || d?.docId) === dataEntryID
  );

  return dataEntry || null;
};

